// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"324":"407cbdc8","630":"4c4f953e","875":"0187695c"}[chunkId] + ".css";
};